export function isWebGpuError(error: unknown): boolean {
	const message = (error instanceof Error ? error.message : String(error)).toLowerCase();
	return (
		message.includes('webgpu') ||
		message.includes('gpu adapter') ||
		message.includes('context provider') ||
		message.includes('failed to find gpu')
	);
}
